app.controller("LecturerCardController", ["$scope", "Lecturer", "Users", "Session", "StaticData", "$uibModal", "LecturerService", "$stateParams", "$state", "usSpinnerService",
    function ($scope, Lecturer, Users, Session, StaticData, $uibModal, LecturerService, $stateParams, $state, usSpinnerService) {
        var lecturerId = $stateParams.lecturerId;
        var now = new Date();
        $scope.years = _.range(2017, now.getFullYear() + 1);
        $scope.year = $stateParams.year || now.getFullYear().toString();
        $scope.season = $stateParams.season ? $stateParams.season : now.getMonth() < 7 ? 'spring' : 'autumn';
        $scope.selectedSeason = $stateParams.season || $scope.year + '-' + $scope.season;


        StaticData.getItemsByKey("subject_seasons").then(function (seasons) {
            $scope.seasons = [].concat(seasons);
            $scope.seasonsMap = _.keyBy($scope.seasons, '_id');

            $scope.selectSeasons = [];
            $scope.years.forEach(function (year) {
                $scope.seasons.forEach(function (season) {
                    $scope.selectSeasons.push({
                        _id: year + '-' + season._id,
                        name: year + ' ' + season.name
                    })
                })
            })
        });

        $scope.$watch('selectedSeason', function (val) {
            if (val) {
                var strings = val.split('-');
                $scope.year = strings[0];
                $scope.season = strings[1];
            }
        }, true);

        $scope.load = function () {
            $state.go(".", {season: $scope.selectedSeason});
        };

        $scope.loadData = function () {
            usSpinnerService.spin("root");
            Users.profile(lecturerId).then(function (data) {
                $scope.lecturer = data;
                Session.groupListByLecturerId({
                    lecturer: lecturerId,
                    season: $stateParams.season || $scope.selectedSeason,
                }).then(function (data) {
                    $scope.sessions = data;
                    $scope.totalItems = data.length;
                    usSpinnerService.stop("root");
                })
            });

        };

        $scope.loadData();

        $scope.showDetails = function (session) {
            $state.go("admin.lecturerGroup", {groupId: session._id});
        };

        $scope.sessionTypeText = function(type){
            return type === 'lecture' ? 'ლექცია' : 'სემინარი';
        };
    }
]);
